import Chart from 'react-google-charts'

const pieOptions = {
  pieHole: 0.3,
  sliceVisibilityThreshold: 0,
  chartArea: {
    left: 25,
    bottom: 10,
    height: 250,
    width: 700
  },
  legend: { 
    position: "top",
    maxLines: 5,
    textStyle: {
      fontSize: 11
    }
  },
}

interface Props {
  results: any;
}

const DigitalWalletChart: (props: Props) => JSX.Element = (props: Props) => {
  let pieData;
  const fetchedData = props.results.map( (item: any) => {
    const balance = +item.total_incoming_value_usd - +item.total_outgoing_value_usd;
    const finalBalance = balance > 0 ? balance : 0;
    return [item.token_symbol, finalBalance];
  });
  pieData = [ ['Currency', 'Balance'], ...fetchedData ];

  return (
    <Chart
      width='100%'
      height={'360px'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      data={pieData}
      options={pieOptions}
      rootProps={{ 'data-testid': '3' }}
    />
  );
};

export default DigitalWalletChart;
